export default function Marquee({ text = "QUALITY > EVERYTHING", text2 = null, variant = "solid", speed = "normal" }) {
  const phrases = text2 ? [text, text2] : [text];
  const items = Array.from({ length: 8 }, (_, i) => phrases[i % phrases.length]);
  const outline = variant === "outline";
  const content = (
    <div
      className={`flex shrink-0 items-center gap-8 pr-8 ${
        speed === "fast" ? "animate-marquee-fast" : "animate-marquee"
      }`}
    >
      {items.map((t, i) => (
        <span key={`${t}-${i}`} className="flex items-center gap-8">
          <span
            className={`font-display font-extrabold text-3xl md:text-5xl uppercase tracking-tight ${
              outline ? "text-stroke" : "text-white"
            }`}
          >
            {t}
          </span>
          <span className="text-[hsl(var(--accent))] text-2xl md:text-4xl">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`flex overflow-hidden py-5 ${
        outline
          ? "border-y border-slate-200 bg-[hsl(210_20%_98%)]"
          : "border-y border-[hsl(213_74%_22%)] bg-[hsl(var(--primary))]"
      }`}
      data-testid="marquee"
    >
      {content}
      {content}
    </div>
  );
}
